import React from "react";

const Websitetoolcard = ({ img, title, des, link }) => {
  return (
    <div>
      <div className="w-full max-w-md px-8 py-4 mt-16 bg-white rounded-lg shadow-lg dark:bg-gray-800">
        <div className="flex justify-center -mt-16 md:justify-end">
          <img alt="Testimonial avatar" src={img} />
        </div>

        <h2 className="mt-2 text-2xl font-semibold text-gray-800 dark:text-white md:mt-0 md:text-3xl">
          {title}
        </h2>

        <p className="mt-2 text-gray-600 dark:text-gray-200 mb-4">{des}</p>
      </div>
    </div>
  );
};

export default Websitetoolcard;
